import React, { Component } from "react";
import { connect } from "react-redux";
import ErrorAction from "../../../../Redux/ErrorRedux";
import Container from "../../../../modules/commons/Container";
import { fetchDataAsync, getUserAccess } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { mapToObjectDDL } from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../../modules/SimpleDDL";
import { TABS } from "./constants";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import CrmFollowUpH23Tab from "./components/crmFollowUpH23Tab";

class CrmFollowUpH23 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCabang: [],
      selectedCabang: null,
      loading: false,
      activeTab: 0,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "CRM FollowUp Prospek H23",
      args: null,
    });
    this.handleTriggerLoading();
    if (!res.ok || !res.data?.data) return;

    const cabangUser = this.props.menuAccess.map((a) => a.idRefObj);
    const filtered = res.data.data.filter((c) =>
      cabangUser.includes(c.kodeCabang)
    );

    if (filtered.length > 0) {
      const mappedCabang = filtered.map((c) =>
        mapToObjectDDL(c.namaDealer, c.kodeCabang)
      );
      const firstCabang = mappedCabang[0];

      this.setState({
        dataCabang: mappedCabang,
        selectedCabang: firstCabang,
        userAccess: getUserAccess(this.props.menuAccess, firstCabang.value),
      });
    }
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ loading: !prev.loading }));
  };

  handleSelectCabang = (value) => {
    this.setState({ selectedCabang: value });
  };

  handleSelectTab = (value) => {
    this.setState({ activeTab: value });
  };

  render() {
    const { loading, dataCabang, selectedCabang, activeTab } = this.state;
    const arrTab = Object.values(TABS);
    return (
      <React.Fragment>
        <Container>
          <SimpleDDL
            id="dropdown_kode_cabang"
            options={dataCabang}
            value={selectedCabang}
            box="search"
            name="selectedCabang"
            containerclassname="width width-280px"
            onChange={this.handleSelectCabang}
          />
          <Tabs selectedIndex={activeTab} onSelect={this.handleSelectTab}>
            <TabList>
              {arrTab.map((tab) => (
                <Tab key={tab}>{tab}</Tab>
              ))}
            </TabList>

            {arrTab.map((tab) => (
              <TabPanel key={tab}>
                <CrmFollowUpH23Tab
                  {...this.props}
                  tab={tab}
                  activeTab={activeTab}
                  selectedCabang={selectedCabang}
                  onTriggerLoading={this.handleTriggerLoading}
                />
              </TabPanel>
            ))}
          </Tabs>
        </Container>
        <SimpleLoadingOverlay active={loading} />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        auth: state.auth,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CrmFollowUpH23);
